import { Logger } from 'vue-infra';
import { appName } from '../common/consts';

const logger = Logger.getLogger(appName);

/**
 * loads an i18n dictionary module to the memory.
 *
 * @param filename - the desired filename under the i18n dictionaries directory.
 * @returns {Promise<JSON>} a promise that will be resolved with the loaded module.
 */
export const loadDictionary = filename =>
  require(`./dictionaries/${filename}.json`);

/**
 * loads the application i18n dictionaries, and collects them to an object ready to be mixed-in to the
 * application-init configuration.
 *
 * @param locale - the desired locale of the main dictionary to load.
 * @param fallbackLocale - a fallback locale.
 * @returns {Promise<JSON>} an object with the custom and fallback dictionaries, in the form:
 *   {
 *     localeResource: JSONObject,
 *     fallbackLocaleResource: JSONObject,
 *   }
 */
export const loadI18nResources = (locale, fallbackLocale) => {
  const resources = {};
  try {
    resources.appLocaleResource = loadDictionary(locale);
  } catch (error) {
    logger.error(`fail to load dictionary ${locale}`);
    if (locale === fallbackLocale) {
      throw error;
    }
  }
  if (locale !== fallbackLocale) {
    try {
      resources.appFallbackLocaleResource = loadDictionary(fallbackLocale);
    } catch (error) {
      logger.error(`fail to load fallback dictionary ${fallbackLocale}`);
      throw error;
    }
  }
  return resources;
};
